export default __webpack_public_path__ + "static/media/swp.6e256653.svg";